import { type Common } from '../common.js';
import { type PaginatedQueryOptions } from '../models/pagination/PaginatedQueryOptions.type.js';
import { type PaginationResponse } from '../models/pagination/PaginationResponse.type.js';
import {
  type CreateValues,
  type FindAllOptions,
  type PreviewUrls,
  type PrevisitLinkWithTemplates,
  type UpdateValues,
} from '../models/previsit/link.js';

export class API {
  common: Common;
  baseEndpoint = '/previsit/links';

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(options: FindAllOptions = {}): Promise<PrevisitLinkWithTemplates[]> {
    const url = this.common.constructPath(this.baseEndpoint, options);
    return await this.common.getJSON(url);
  }

  async findAllPaginated(
    options: PaginatedQueryOptions<FindAllOptions>
  ): Promise<PaginationResponse<PrevisitLinkWithTemplates>> {
    const url = this.common.constructPath(this.baseEndpoint, options);
    return await this.common.getJSON(url);
  }

  async findOneById(id: string): Promise<PrevisitLinkWithTemplates> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.getJSON(url);
  }

  async create(values: CreateValues): Promise<PrevisitLinkWithTemplates> {
    const url = this.common.constructPath(this.baseEndpoint);
    return await this.common.postJSON(url, values);
  }

  async update(id: string, values: UpdateValues): Promise<PrevisitLinkWithTemplates> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.patchJSON(url, values);
  }

  async remove(id: string): Promise<void> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.deleteJSON(url);
  }

  async fetchPreviewUrls(args: { linkId: string; practiceId?: string }): Promise<PreviewUrls> {
    const { linkId, practiceId } = args;
    const url = this.common.constructPath(
      `${this.baseEndpoint}/${linkId}/preview-urls`,
      practiceId ? { practiceId } : undefined
    );
    return await this.common.getJSON(url);
  }
}
